// Requires: src/checkout-state.js

(function($, CheckoutState) {
	'use strict';

	var $el         = $('[data-checkout-delivery]');
	var $options    = $('[data-checkout-delivery-option]');
	var REQUEST_URL = $el.data('requestUrl');
	var $dataSourceItemId = $el.data('datasource');

	if($options.length) {
		$options.on('change', handleOptionChange);
	}

	function handleOptionChange(e) {
		var deliveryIdSelected = e.currentTarget.value;

	    $.getJSON(REQUEST_URL, { deliveryId: deliveryIdSelected, dataSourceId: $dataSourceItemId })
			.done(handleSuccess)
			.fail(handleFail);
	}

	function handleSuccess(data) {
		if(data.error) {
			// deal with the error
		} else {
			// Update the state
			CheckoutState.state.set(CheckoutState.state.type.summary, data.totals);
		}
	}

	function handleFail(e) {
		console.log('failed');
		console.log(e);
	}


})($jq, window.BOL.Checkout.State);
